
<template>
  <div>
    <PassWordReSet></PassWordReSet>
  </div>
</template>

<script>
import PassWordReSet from "@/components/shoplus_service/partners/PassWordReSet.vue";

export default {
  components: {
    PassWordReSet
  }
};
</script>